import React from 'react';
import { observer } from 'mobx-react';
import { IntlShape } from 'react-intl';
import classnames from 'classnames';
import { IMeetingArtifactDTO } from '../../../../../api/artifacts.dao';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';
import MeetingArtifactListItemDay from './meeting-artifact-llist-day-item/meeting-artifact-list-day-item';
import ArtifactItem from './artifact-item/artifact-item';
import Text from '../../../../global/text/text';

import './meeting-artifact-list-item.scss';
import ArtifactsViewModel from '../artifacts.viewmodel';

interface IMeetingArtifactListItemProps {
    meeting: IMeetingArtifactDTO;
    eventTimeZone: string;
    intl: IntlShape;
    colspan: number;
    dateTimeFormatter: DateTimeFormatter;
    downloadArtifactPermission: boolean;
    deleteArtifactPermission: boolean;
    deleteArtifactDownloadLinkPermission: boolean;
    isLastMeeting: boolean;
    vm: ArtifactsViewModel;
}

const MeetingArtifactListItem = observer(({
    meeting,
    vm,
    eventTimeZone,
    intl,
    colspan,
    dateTimeFormatter,
    downloadArtifactPermission,
    deleteArtifactPermission,
    deleteArtifactDownloadLinkPermission,
    isLastMeeting,
}: IMeetingArtifactListItemProps) => {
    const {
        artifacts,
        presenters = [],
        topic,
        type,
        startDateTime,
        meetingId
    } = meeting;

    const [firstArtifact, ...restArtifacts] = artifacts;
    const defaultRowSpan = 1;
    const rowSpan = restArtifacts?.length ? (restArtifacts.length + defaultRowSpan) : defaultRowSpan;

    return (
        <>
            <tr className={classnames('meeting-artifact-list-item meeting-row', {'meeting-row-cell': isLastMeeting})}>
                {!startDateTime
                    ? <td colSpan={colspan} className='empty'></td>
                    : <>
                        <td rowSpan={rowSpan}>
                            <MeetingArtifactListItemDay
                                eventTimeZone={eventTimeZone}
                                startDateTime={new Date(startDateTime)}
                                dateTimeFormatter={dateTimeFormatter}
                            />
                        </td>
                        <Text tag='td' message={topic} withEllipsis />
                        <Text tag='td' message={presenters.join(', ')} withEllipsis />
                        <Text tag='td' message={type} withEllipsis />
                    </>
                }
                <ArtifactItem
                    renderInTableRow
                    intl={intl}
                    artifact={firstArtifact}
                    downloadArtifactPermission={downloadArtifactPermission}
                    deleteArtifactPermission={deleteArtifactPermission}
                    meetingId={meetingId}
                    deleteArtifactDownloadLinkPermission={deleteArtifactDownloadLinkPermission}
                    vm={vm}
                />
            </tr>
            {!!restArtifacts?.length && restArtifacts.map(artifact => (
                <ArtifactItem
                    key={artifact.assetMetadataId}
                    intl={intl}
                    artifact={artifact}
                    colspan={!startDateTime ? colspan : colspan - 1}
                    downloadArtifactPermission={downloadArtifactPermission}
                    deleteArtifactPermission={deleteArtifactPermission}
                    meetingId={meetingId}
                    deleteArtifactDownloadLinkPermission={deleteArtifactDownloadLinkPermission}
                    vm={vm}
                />
            ))}
        </>
    );
});

export default MeetingArtifactListItem;
